<template>
  <div class="emergency">
    <h2>鹏扬基金客户应急处理提示</h2>
    <p class="p-tit">{{title}}</p>
    <h3>一、	临柜办理需要提供如下资料：</h3>
    <div>
      <p v-for="(item, index) in resource1" :key="index">
        <span>{{item}}</span>
        <button v-if="index==1" @click="jumpDown(index,'url1')" id="url1" data-clipboard-text="https://www.pyamc.com/front/contentDetail_100354_11134.jhtml">【下载地址】</button>
      </p>
      <p class="p-tel">柜台地址及联系方式：</p>
      <p>{{addr}}</p>
      <p>{{tel}}</p>
    </div>

     <h3>二、	远程办理需要提供如下资料：</h3>
    <div>
      <p v-for="(item, index) in resource12" :key="index">
        <span>{{item}}</span>
        <button v-if="index==2" @click="jumpDown(index,'url2')" id="url2" data-clipboard-text="https://www.pyamc.com/front/contentDetail_100354_11134.jhtml">【下载地址】</button>
      </p>
      <p class="p-cont">
        {{content}}
      </p>
      <p class="p-tel">柜台地址及联系方式：</p>
      <p>{{addr}}</p>
      <p>{{tel}}</p>
    </div>
    <h3>特别提示：</h3>
    <div>
      <p v-for="(item, index) in tip" :key="index">
        <span>{{item}}</span>
      </p>
    </div>
  </div>
</template>
<script>
import Clipboard from 'clipboard'
export default {
  data(){
    return{
      title:"我司通过鹏扬基金官网www.pyamc.com、微信公众号“鹏扬基金”、手机APP“鹏扬好基通”为客户提供7*24小时直销交易服务。当上述某一平台出现临时故障时，请切换到其他平台办理，若上述3个平台都出现故障，您还可以通过临柜办理或远程办理方式进行操作：",
      resource1:[
        "1)	投资者本人有效身份证件原件；",
        "2)	办理基金认/申购、赎回、转换等业务，提供填写完整的《交易类业务申请表》等相关交易表单；",
        "3)	办理基金申购业务，应在15：00之前从预留银行账户将足额申购资金划至本公司指定的直销专户(直销专户详见《交易类业务申请表》)，并提供银行转账汇款回单（网银汇款截图）；",
        "4)	办理基金认购业务，应在17：00之前从预留银行账户将足额认购资金划至本公司指定的直销专户(直销专户详见《交易类业务申请表》)，并提供银行转账汇款回单（网银汇款截图）；",
        "5)	本公司直销中心要求提供的其他有关材料。"
      ],
      resource12:[
        "1)	投资者本人手持身份证正面拍照；",
        "2)	投资者本人有效身份证件复印件（正反面）",
        "3) 办理基金认/申购、赎回、转换等业务，提供填写完整的《交易类业务申请表》等相关交易表单；",
        "4)	办理基金申购业务，应在15：00之前从预留银行账户将足额申购资金划至本公司指定的直销专户(直销专户详见《交易类业务申请表》)，并提供银行转账汇款回单（网银汇款截图）；",
        "5) 办理基金认购业务，应在17：00之前从预留银行账户将足额认购资金划至本公司指定的直销专户(直销专户详见《交易类业务申请表》)，并提供银行转账汇款回单（网银汇款截图）；",
        "6) 本公司直销中心要求提供的其他有关材料。"
      ],
      tip:[
        "1)	在进行上述应急处理中，您的委托可能遇到因网络原因无法传输、风险问卷过期、购买产品风险等级高于客户风险承受能力、客户信息与反洗钱要求不符、产品停止认/申购、由于不可抗力导致的其它风险等原因导致委托无法提交的情况，届时请及时沟通客服并以客服反馈的业务规定为准。",
        "2)	业务的费率及费率折扣等参照直销柜台相关交易执行。",
        "3)	具体交易是否允许撤单以及申请撤单的时间要求，请以基金法律文件和相关公告为准。"
      ],
      content:"远程办理您可选择电子邮件（service@pyamc.com）、传真（010-81922890）提供资料，须通过客服热线或在线客服沟通确认是否收到该笔交易业务资料。电子版资料须于当前交易日15:00前提交，以我司收到的时间为准，并于5个交易日内将相关纸质版原件邮寄至鹏扬基金。",
      addr:"地址：北京市石景山区绿地环球文化金融城9号院5号楼1401-1405（100043）",
      tel:"客服电话：400-968-6688"
      }
  },
  mounted(){
    document.body.style.backgroundColor="#fff"
  },
  methods: {
    jumpDown(n,url){
      var clipboard = new Clipboard('#'+url)
      clipboard.on('success', e => {
          //  释放内存
        //  clipboard.destory()
        this.$alert('链接已复制剪切板，请粘贴到浏览器打开，下载申请表', '复制成功', {
          confirmButtonText: '确定',
          callback: action => {
            if(n==1){
              window.location.href="https://www.pyamc.com/front/contentDetail_100354_11134.jhtml"
            }else{
              window.location.href="https://www.pyamc.com/front/contentDetail_100354_11134.jhtml"
            }
          }
        })
       
      })
      
     
    },
  }
}
</script>
<style scoped lang="scss">
@media screen and (min-width:320px) and (max-width:750px){
.emergency{
  background: #fff;
  padding: 0.4rem;
  font-size: 0.4rem;
  line-height: 0.6rem;
  h2{
    text-align: center;
    font-size: 0.5rem;
    line-height: 1.2rem;
  }
  h3{
    font-size: 0.4rem;
    margin-top:0.5rem;
    margin-bottom:0.1rem;
  }
  .p-tit{
    text-indent: 0.7rem;
    
  }
  button{
    background: rgba($color: #000000, $alpha: 0);
    border:0;
    color:#00bfff;
  }
  .p-tel{
    margin-top: 0.4rem;
  }
  .p-cont{
    text-indent: 0.7rem;
    word-wrap:break-all;
    margin-top:0.4rem;
  }
}
}
@media screen and (min-width:750px){
.emergency{
  background: #fff;
  padding: 50px 150px;
  font-size:16px;
  line-height: 25px;
  h2{
      text-align: center;
      font-size: 18px;
      line-height: 20px;
      margin-bottom:10px;
    }
  h3{
    font-size: 16px;
    margin-top:10px;
    margin-bottom:5px;
  }
  button{
    background: rgba($color: #000000, $alpha: 0);
    border:0;
    color:#00bfff;
  }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/h5/emergencyText.vue